// extracted by mini-css-extract-plugin
export var closeButton = "_u-1";
export var container = "_u-0";
export var fullModalImage = "_u-2";